<!-- eslint-disable -->
<template lang="pug">
    modal(@close="handleCloseModal")
        div(slot="header") {{ $i18n.t('billing.billing_modal_balanceChanging') }}
        .modal__body
            .body__header
                hr
                .body__amount
                    span {{ profile.name || profile.fullName }}
                    span &nbsp;
                    span {{ balanceString }}
            .body__body
                .body__turtle
                    img.turtle__image(:src="TurtleWithCup")
                .body__phrase(v-html="clevikPhrase")
            .body__footer
                .body__amount {{ newBalanceString }}
                help-text.body__info
                    | {{ infoText }}
        div(slot="footer")
            hr
            .modal__buttons
                .modal__button-container
                    cs-button(
                        type="button"
                        color="blue"
                        :loading="isLoading"
                        :disabled="errors.has('number')"
                        @click="updateBalance"
                    )
                        | {{ $i18n.t('billing.billing_modal_changeBalance') }}
                .modal__button-container
                    cs-button(
                        type="button"
                        color="blue"
                        pattern="primary-outline"
                        @click="handleCloseModal"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationUsers_confirm') }}
</template>

<script>
    /*eslint-disable*/
    import Modal from '../../elements/CsModal.vue';
    import AccountApi from '../../api/billing/account';
    import TurtleWithCup from '../../assets/images/TurtleWithCup.svg'
    import {mapState} from 'vuex';
    import modulBankPaymentMixin from "../../utils/modulBankPaymentMixin";

    export default {
        props: {
            profile: Object,
            needToPay: {
                type: Number,
                default: null
            },
            user: Object,
        },
        components: {
            Modal
        },
        mixins: [modulBankPaymentMixin],
        data () {
            return {
                isLoading: false,
                TurtleWithCup
            }
        },
        methods: {
            updateBalance () {
                this.$validator.validateAll()
                .then(response => {
                    if (response && this.roundedNeedToPay) {
                        this.isLoading = true;
                        let schoolId = this.profile.type === 'student'
                                ? this.profile.schools.find(school => school.studentPayed).id
                                : undefined;
                        AccountApi.updateAccountBalance(this.profile.account.id, {
                            balance: this.roundedNeedToPay,
                            comment: this.comment,
                            schoolId: schoolId
                        })
                        .then(data => {
                            if (!this.authUser.isSuperadmin) {
                                if (data.url.includes('https://pay.modulbank.ru/pay')) {
                                    this.redirectToModulBank(data.url);
                                } else {
                                    document.location = data.url;
                                }
                            }
                        })
                        .catch(err => this.$toasted.error(err));
                    }
                })
                .then(() => {
                    this.isLoading = false;
                    if (this.roundedNeedToPay > 0) {
                        this.$toasted.success(this.$i18n.t('billing.billing_modal_' + this.successMessage));
                    }
                    this.$emit('close');
                })
                .catch(() => {
                    this.isLoading = false;
                })
            },
            formatBalance (balance) {
                const formatter = new Intl.NumberFormat('ru-RU', {
                    style: 'currency',
                    currency: 'RUB',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
                return formatter.format(balance);
            },
            handleCloseModal () {
                AccountApi.updatePaymentNotification(this.profile.account.id)
                .then(() => {
                    this.$emit('close')
                })
                .catch(() => {
                    this.$toasted.error(this.$i18n.t('error.error_has_occurred'))
                })
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            }),
            balanceString () {
                return this.formatBalance(this.profile.account.balance);
            },
            newBalanceString () {
                return this.$i18n.t('miles.miles_modal_total') + " "
                        + this.formatBalance(this.profile.account.balance + this.roundedNeedToPay);
            },
            total () {
                return Math.round((this.profile.account.balance + this.balance) * 100) / 100;
            },
            infoText () {
                if (!this.authUser.isSuperadmin) {
                    return this.$i18n.t('olympiads.olympiads_success_helpText')
                            + this.$i18n.t('olympiads.olympiads_helpText_support')
                            + this.$i18n.t('olympiads.olympiads_helpText_mail');
                }
                return "";
            },
            clevikPhrase () {
                return this.$i18n.t('billing.billing_payPopup_notEnoughMoney', {
                    sex: this.$i18n.t("billing.billing_popup_sex")[this.user.sex],
                    name: this.user.fullName,
                    difference: this.formatBalance(this.roundedNeedToPay)
                })
            },
            roundedNeedToPay () {
                return Math.round(this.needToPay * 100) / 100;
            },
            successMessage () {
                return this.authUser.isSuperadmin ? 'moneyWasAdded' : 'invoiceWasCreated';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal__buttons {
        margin: -10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .modal__button-container {
        padding: 10px;
    }

    .body__amount {
        font-weight: bold;
        font-size: 24px;
    }

    .body__body {
        margin: 10px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .body__turtle {
        display: none;
        margin-right: 25px;
        @include media($md) {
            display: block;
        }
    }

    .turtle__image {
        max-width: 300px;
        max-height: 300px;
    }

    .body__phrase {
        min-width: 0;
        max-width: none;
        height: fit-content;
        font-weight: 400;
        font-size: 1.1rem;

        padding: 15px 15px;
        margin-bottom: 10px;
        text-align: center;
        color: $x-color-white;
        border: 3px solid darken($hsl-color-green-58, 10);
        background: $hsl-color-green-58;
        border-radius: 30px;
    }

    .body__info {
        font-size: 16px;
    }
</style>
